import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../services/authService';
import './Login.css';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage(null);
    setLoading(true);
    try {
      const result = await authService.forgotPassword(email.trim());
      setMessage(result.message);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erro ao enviar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Esqueci minha senha</h1>
        <p>Informe o e-mail da sua conta (clínica ou administrador) para receber um link e redefinir a senha.</p>

        {error && <div className="error-message">{error}</div>}
        {message && <div className="alert alert-success" style={{ marginBottom: '1rem' }}>{message}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
              disabled={loading}
              className="form-control"
              autoComplete="email"
            />
          </div>
          <button type="submit" className="btn btn-primary btn-login" disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar link por e-mail'}
          </button>
        </form>

        <p style={{ marginTop: '1.5rem', fontSize: '0.9rem' }}>
          <Link to="/login">Voltar ao login</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
